// extracted by mini-css-extract-plugin
export default {"dropdown_menu1":"MyClass_dropdown_menu1__LqSUS","Hr3":"MyClass_Hr3__KleYs","menu1":"MyClass_menu1__Ht7ot","menuList":"MyClass_menuList__8OPkd"};